// eslint-disable-next-line no-unused-vars
const noop = (...args) => {};

export { noop };
